export const WEB_FILTER_LIST_KEY = 'www.web-filters';
